import { gql } from '@apollo/client';
import { MEETING_BASIC_INFO } from './meeting';

export const EXPERT_BASIC_DATA = `
  id
  fullName
  country
  employmentHistory {
    id
    title
    organization {
      id
      name
      type
    }
    isCurrent
  }
  title
  organization {
    id
    name
    type
  }
  credentials
  publicLinks
  profile_picture
  functions
  medical_specialties
  technology_tags
  credits
  numCompleted
  profileUpdatedAt
  wizaUpdatedAt
  teamData {
    avgRating
    numEngagements
  }
`;

export const SCHEDULE_EXPERT_WIZA_UPDATES = gql`
  mutation ScheduleExpertWizaUpdates($expertIds: [ID!]!, $forceUpdate: Boolean) {
    scheduleExpertWizaUpdates(expertIds: $expertIds, forceUpdate: $forceUpdate) {
      id
      profileUpdatedAt
      wizaUpdatedAt
    }
  }
`;

const EXPERT_PROFILE = gql`
  query Expert($id: String!) {
    expert(id: $id) {
      ${EXPERT_BASIC_DATA}
      description
      user {
        id
        upcomingMeetings {
          id
        }
        pendingJobs {
          id
        }
        pastJobs {
          id
          ratingOnExpert
        }
      }
    }
  }
`;

export const EXPERT_JOBS_HISTORY = gql`
  query User($id: String!) {
    user(id: $id) {
      id
      pendingJobs {
        ${MEETING_BASIC_INFO}
      }
      currentJobs {
        ${MEETING_BASIC_INFO}
      }
      pastJobs {
        ${MEETING_BASIC_INFO}
      }
    }
  }
`;

export const SEARCH_EXPERTS = gql`
  query SearchExperts($queries: [String!]!, $filters: [SearchFilter], $exclusions: [SearchExclusion], $page: Int) {
    searchExperts(queries: $queries, filters: $filters, exclusions: $exclusions, page: $page) {
      total
      items {
        item {
          __typename
          ... on Expert {
            ${EXPERT_BASIC_DATA}
            user {
              id
              pendingJobs {
                id
              }
            }
          }
        }
        highlights {
          field
          segments
        }
        matchedQueries {
          query
          items {
            __typename
            ... on Project {
              id
              title
            }
          }
        }
      }
      facets {
        id
        categoryId
        name
        items {
          value
          count
        }
      }
    }
  }
`;

export const COUNT_EXPERTS = gql`
  query SearchExperts($queries: [String!]!, $filters: [SearchFilter], $exclusions: [SearchExclusion]) {
    searchExperts(queries: $queries, filters: $filters, exclusions: $exclusions) {
      total
    }
  }
`;

export default EXPERT_PROFILE;
